import { groupBy, uniqBy } from 'lodash';
import { cropNameForRow, rowHasPattern } from './points-and-rows/rows';
import { getCropId } from './meta';

export const getCropUsageForSections = ({ cropNameToId, fieldSections }) => {
  const sectionsByCrop = fieldSections.flatMap((section) => {
    const { crop, primaryInRowPattern, rowOverrides, rows } = section;
    // Iterate over the rows in the section and build an array of row indices for each crop
    const rowsByCrop = (rows?.features || []).reduce((byCrop, _, rowIndex) => {
      const override = rowOverrides[rowIndex];
      if (rowHasPattern(override, { primaryInRowPattern })) return byCrop;
      const cropName = cropNameForRow(override, {
        crop,
        primaryInRowPattern,
      });
      const cropId = getCropId({ name: cropName }, cropNameToId);
      const cropData = byCrop[cropId] || {
        cropId,
        rowIndices: [],
        section,
      };
      cropData.rowIndices.push(rowIndex);
      return { ...byCrop, [cropId]: cropData };
    }, {});
    return Object.values(rowsByCrop);
  });
  return groupBy(sectionsByCrop, 'cropId');
};

export const getCropUsageForPatterns = (inRowPatternsMap) =>
  groupBy(
    Object.values(inRowPatternsMap).flatMap((pattern) =>
      uniqBy(
        pattern.cropSequence.map(({ crop }) => ({ cropId: crop?.id, pattern })),
        'cropId',
      ),
    ),
    'cropId',
  );

export const getFarmCropUsage = ({
  cropNameToId,
  fieldSections,
  inRowPatternsMap,
}) => ({
  patternsByCrop: getCropUsageForPatterns(inRowPatternsMap),
  sectionsByCrop: getCropUsageForSections({ cropNameToId, fieldSections }),
});
